import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { OelButtonWrapper } from './wrapper/OelButtonWrapper';
import * as React from 'react';
import { WaermeButtonWrapper } from './wrapper/WaermeButtonWrapper';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { hasEnergietraegerRechner } from '../../functions/hasEnergietraegerRechner';

export function getAssistentConfigWaerme(standort: any, data: any, jahr: number, triggerService: TriggerService, customCfg?: AssistentItem): AssistentItem {
    // console.log('Prozesswärme',prozesswaermeRelevant,  wz_obj, customFormConfig);
    const eingabe_waerme = {
        gliederung: '2.2',
        name: 'Wärme/Brennstoffe',
        dataName: 'Wärme',
        description: 'Dies ist das Formular zur Eingabe der Wärme-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_ENERGIEDATEN_WAERME,
        style: { marginLeft: 18 },
        configFlag: 'inputWaerme',
        customOnChange: customOnChange,
        addLabel: 'Neuen Wärme-Datensatz erfassen',
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_WAERME);
        },
        getExtraElement: (tmp1: boolean, tmp2: any, tmp3: number, tmp4: any, values: any, setValues: (values: any) => void, disabled?: boolean) => {
            if (values && (values.energietraeger_tid_orig > 0 || values.energietraeger_tid > 0)) {
                const hasER = hasEnergietraegerRechner(values);
                // console.log(hasER, values);
                if (hasER) {
                    return <OelButtonWrapper
                        jahr={jahr}
                        standortSelected={standort}
                        values={values}
                        data={data}
                        callback={setValues}
                    />;
                } else {
                    return values.abrechnungsmodus === 2 // {2} Monatsrechnungen
                        ? <WaermeButtonWrapper
                            jahr={jahr}
                            standortSelected={standort}
                            values={values}
                            data={data}
                            callback={setValues}
                            disabled={disabled}
                        />
                        : null
                }
            }
            return null;
        },
        ...(customCfg || {})
    };
    return eingabe_waerme;
}

function customOnChange(dataItem: any, dataGlobal: any, contextService: any, prevDataItem: any) {
    // console.log(dataItem, prevDataItem);
    if (
        // Neuer Datensatz
        (dataItem.tid === 0 && dataItem.waerme_dritte === 1) ||
        // Erste Bearbeitung
        (!prevDataItem.hasOwnProperty('tid') && dataItem.waerme_dritte_name !== 'Ja' && dataItem.waerme_dritte === 1) ||
        // Spätere Bearbeitung
        (prevDataItem.hasOwnProperty('waerme_dritte') && prevDataItem.waerme_dritte !== 1 && dataItem.waerme_dritte === 1) ||
        (prevDataItem.hasOwnProperty('waerme_dritte_orig') && prevDataItem.waerme_dritte_orig !== 1 && dataItem.waerme_dritte_orig === 1)
    ) {
        showWaermeDritteMessage(dataGlobal);
        return;
    }

    // Für weitere Anpassung siehe auch customOnChange in assistent_config_strom.tsx
    if (dataItem.popup_shown) {
        return;
    }
    if (!dataItem.tid || dataItem.tid === 0) {
        if (dataItem.energietraeger_tid_orig === 11 || dataItem.energietraeger_tid === 11) { /* {11} Strom */
            dataItem.popup_shown = true;
            showWaermeEnergietraegerStromMessage();
        }
        if (dataItem.abrechnungsmodus === 2 || dataItem.abrechnungsmodus_orig === 2) {
            showWaermeEnergietraegerEinheitMessage();
            // Default -> 1: siehe setDataPreset in AssistentEntityForm
            dataItem.abrechnungsmodus = 1;
            dataItem.abrechnungsmodus_orig = 1;
        }
    } else {
        const arr = dataGlobal[IDs.ENT_ENERGIEDATEN_WAERME] || [];
        const found = arr.find((item: any) => item.tid === dataItem.tid);
        if (found) {
            if (
                (dataItem.energietraeger_tid_orig === 11 || dataItem.energietraeger_tid === 11)
                && (!found.energietraeger_tid_orig || found.energietraeger_tid_orig !== 11 || !dataItem.energietraeger_tid_orig)
            ) { /* {11} Strom */
                showWaermeEnergietraegerStromMessage();
                dataItem.popup_shown = true;
                dataItem.energietraeger_tid_orig = 11;
            } else if (dataItem.energietraeger_tid === 11 && !found.energietraeger_tid) {
                showWaermeEnergietraegerStromMessage();
                dataItem.popup_shown = true;
                dataItem.energietraeger_tid_orig = 11;
            }
            if (!found.energietraeger_tid_orig && (dataItem.abrechnungsmodus === 2 || dataItem.abrechnungsmodus_orig === 2)) {
                showWaermeEnergietraegerEinheitMessage();
                // Default -> 1: siehe setDataPreset in AssistentEntityForm
                dataItem.abrechnungsmodus = 1;
                dataItem.abrechnungsmodus_orig = 1;
            }
        }
    }
}

function showWaermeDritteMessage(dataGlobal: any) {
    let msg: string;
    if (dataGlobal && dataGlobal.MODUL_SELECTED === 'steuer') {
        msg = 'Wenn Wärme an Dritte abgegeben wird, bitte berücksichtigen, dass hier nur der Anteil in kWh anzugeben ist, der im Betrieb verbleibt.'
            + '\n\n'
            + 'Tragen Sie bitte die weitergeleitete Wärmemenge (also den Anteil, der NICHT für eigene Betriebszwecke verbraucht wurde) in das Feld „Weitergeleitete Wärmemenge“ ein.';
    } else {
        msg = 'Wenn Wärme an Dritte abgegeben wird, bitte berücksichtigen, dass hier nur der Anteil in kWh anzugeben ist, der im Betrieb verbleibt.';
    }
    alert(msg);
}

function showWaermeEnergietraegerEinheitMessage() {
    const msg = 'Bitte wählen Sie zunächst Energieträger und Einheit aus.';
    alert(msg);
}

function showWaermeEnergietraegerStromMessage() {
    const msg = 'Bitte geben Sie hier nur dann Verbrauchsdaten ein, wenn der Strom für Ihre Heizung separat vom restlichen Strom abgerechnet wird und somit nicht bereits zuvor unter "Strom" erfasst wurde (z.B. wenn bei Wärmepumpennutzung ein Wärmepumpentarif vereinbart wurde)';
    alert(msg);
}

export function getAssistentConfigEigenwaerme(): AssistentItem {
    const eingabe_waerme = {
        gliederung: '2.2.1',
        name: 'Eigenwärme',
        description: 'Dies ist das Formular zur Eingabe der Wärme-Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_ENERGIEDATEN_EIGENWAERME,
        configFlag: 'inputEigenwaerme'
    };
    return eingabe_waerme;
}
